// Config plugins provides $config and $apiConfig on global Vue object
export default {
  install (Vue) {
    Vue.$apiConfig = require('./api.json')
    Vue.$config = require('./' + process.env.NODE_ENV + '.json')
  }
}
